// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.

// Fixed values and constraints
export const SCREEN_TYPE_SV = 'SV';
export const DEFAULT_POSITION = 1;
export const DEFAULT_POSITION_MIN = -1;
export const DEFAULT_POSITION_MAX = 300000001;
export const POSITION_MIN = 0;
export const POSITION_MAX = 300000000;
export const DEFAULT_SV_LENGTH = 50000;
export const DEFAULT_THRESHOLD = 1;
export const INTERVAL_DEPTH_MIN = 0;
export const INTERVAL_DEPTH_MAX = 10000;
export const QUALITY_SCORE_MIN = 0;
export const QUALITY_SCORE_MAX = 1;
export const PRESENCE_MIN = 0;
export const PRESENCE_MAX = 100;
export const GENE_NAME_MAX_LENGTH = 1000;

// SV Type
export const SvFilterSvType = {
  Deletion: "Deletion",
  Insertion: "Insertion",
  Inversion: "Inversion",
  Translocation: "Translocation",
  Duplication: "Duplication",
} as const;
export type SvFilterSvTypeKey = keyof typeof SvFilterSvType;

// Zygosity
export const SvFilterZygosity = {
  Unknown: "Unknown",
  Heterozygous: "Heterozygous",
  Homozygous: "Homozygous",
} as const;
export type SvFilterZygosityKey = keyof typeof SvFilterZygosity;

// FlaggedSV
export const SvFilterFlaggedSv = {
  Embedded: "Include Embedded",
} as const;
export type SvFilterFlaggedSvKey = keyof typeof SvFilterFlaggedSv;

// SVs with Ref Genes detected
export const SvFilterOverlapKG = {
  OverlapKG: "overlapKG",
} as const;
export type SvFilterOverlapKGKey = keyof typeof SvFilterOverlapKG;

// SV Reason
export const SvFilterSVReason = {
  Probe: "Probe",
  Length: "Length",
  ProbeAndLength: "ProbeAndLength",
} as const;
export type SvFilterSVReasonKey = keyof typeof SvFilterSVReason;

// SV Breakpoint Molecule Check
export const SvFilterMolCheckItem = {
  Pass: "pass",
  Fail: "fail",
} as const;
export type SvFilterMolCheckKey = keyof typeof SvFilterMolCheckItem;

// Masked
export const SvFilterMasked = {
  ExcludeMasked: "Exclude Masked",
} as const;
export type SvFilterMaskedKey = keyof typeof SvFilterMasked;

// Best SV per Cluster
export const SvFilterBestSVperCluster = {
  ShowBestSVperCluster: "Show best SV per cluster",
} as const;
export type SvFilterBestSVperClusterKey = keyof typeof SvFilterBestSVperCluster;
